import { Button, Checkbox, FormControlLabel } from '@mui/material'
import { useState } from 'react'
import { validateKYC, validateKYCAndUpdate } from '../../services/Customer';
import useService from '../../hooks/useService';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ICustomerSummary } from '../../Models/Customer';

const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result ? reader.result.toString() : '')
        reader.onerror = (error) => reject(error)
    })

const CustomerPanUpload = ({ customerDetail, modalClose, onSuccess }: { customerDetail: ICustomerSummary, modalClose: () => any, onSuccess: () => any }) => {
    const [panStatus, setPanStatus] = useState(customerDetail.kycInfo?.nameProofDocType === "pan" ? false : true)
    const [panDetails, setPanDetails] = useState(customerDetail.kycInfo)
    const [kycStatus, setKycStatus] = useState(customerDetail.kycStatus === "valid" ? "Y" : "I")
    const [documentName, setDocumentName] = useState<any>('')
    const [document, setDocument] = useState([{ uri: '' }])
    const [submitPanDetail, setSubmitPanDetail] = useState(false)
    const [validatePanDetails, setValidatePanDetails] = useState<any>({});
    const [isPan, setIsPan] = useState(false);
    const [isUploadPan, setIsUploadPan] = useState(true);
    const [panVerifyError, setPanVerifyError] = useState("");
    const [isErrorInPanVerification, setErrorInPanVerification] = useState(false);
    const [maskedPanNumber, setMaskedPanNumber] = useState("");
    const [panOperative, setPanOperative] = useState(true);

    const { execute } = useService()

    const handleDocumentChange = async (e: any) => {
        e.preventDefault();
        const file = e.target.files ? e.target.files[0] : null

        const sizeInMB = Number((file.size / (1024 * 1024)).toFixed(2));
        console.log('sizeInMB', sizeInMB)
        if(sizeInMB > 2) {
            setErrorInPanVerification(true)
            setPanVerifyError('Image size is greater than 2mb.')
            return
        }

        if (!file) return
        const base64File = await toBase64(file)
        setDocumentName(e.target.files[0])
        document[0].uri = base64File
        setDocument(document)
        await submitPan(e, base64File.split(',')[1]);
        e.target.value = ''
    }

    const submitPan = async (e: any, pan_front: any) => {
        if (pan_front && !submitPanDetail) {
            let payload: any = {
                "customerRefNo": customerDetail.customerRefNo,
                "docId": "3",
                "frontImage": pan_front
            }

            const { data, error } = await execute(() => validateKYC(payload))

            if (data != null) {
                setValidatePanDetails(data);
                setIsUploadPan(false);
                setIsPan(true);
                setMaskedPanNumber("********" + data.doc_id?.substring(7, 10));
            } else {
                setErrorInPanVerification(true);
                if (error)
                    setPanVerifyError(error?.reason!)
                else
                    setPanVerifyError("Invalid Image Uploaded");
            }
        }
    }
    const handleSubmit = async () => {
        let payload: any = {
            "customerRefNo": customerDetail.customerRefNo,
            "docId": "3",
            "frontImage": document[0].uri.split(',')[1],
            "partnerId" : customerDetail.partnerId,
            // panOperative: panOperative ? "operative" : undefined
        }
        const { data, error } = await execute(() => validateKYCAndUpdate(payload))

        if (data === null) {
            setErrorInPanVerification(true);
            if (error) {
                setPanVerifyError(error?.reason!);
            }
            setPanVerifyError("Provided Image is Invalid. Please Try Again.");
        } else {
            setValidatePanDetails(data);
            setSubmitPanDetail(true);
            setIsPan(false);
            // setMaskedPanNumber("********" + validatePanDetails.doc_id.substring(7, 10));
            if (panStatus)
                setPanStatus(false);
                onSuccess()
            modalClose()
        }
    }
    return (
        <div className='panContainer'>
            {
                kycStatus === 'Y' && panDetails && panDetails.nameProofDocNo && (
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }} >
                        <div className="panMessageBlock">
                            <div className="panMessage">
                                Pan is already Verified.
                                <span>
                                    <img src={"/assets/images/greentick.png"} alt={"tick"} className="greenTick" width={15} />
                                    {"********" + panDetails?.nameProofDocNo?.substring(7, 10)}
                                </span>
                            </div>
                        </div>
                        <div className={"changeButtonSection"}>
                            <Button className="uploadDocuments" onClick={e => {
                                setPanStatus(true)
                                setPanDetails(undefined)
                            }}>
                                Change PAN
                            </Button>
                        </div>
                    </div>
                )
            }
            {panStatus && (
                <>
                    {isUploadPan && (
                        <div className="panDetails">
                            <div className="documentUpload">
                                {panStatus && panDetails && (
                                    <span className="profileUpdatePan">
                                        Add Pan details
                                    </span>)}
                                {panStatus && !panDetails && (
                                    <>
                                    <div className="panMessageBlock">
                                        <div className="panMessage">
                                            Pan details are mandatory
                                        </div>
                                    </div>
                                    <div className="panMessageBlock" style={{background:'#ffe0e0'}}>
                                        <div className="panMessage" style={{color:'#640000'}}>
                                            Image size should not be greater than 2mb
                                        </div>
                                    </div>
                                    </>
                                )}
                                <div className="documents">
                                    <div className="upload">
                                        <input
                                            accept="image/*"            
                                            type="file"
                                            id="select-image"
                                            style={{ display: 'none' }}
                                            onChange={async (e) => {
                                                await handleDocumentChange(e);
                                            }}
                                        />
                                        <label htmlFor="select-image">
                                            <div className="uploadDocument">
                                                UPLOAD DOCUMENT
                                            </div>
                                        </label>
                                        <img src={'/assets/images/Vector.png'}
                                            alt="Picture of the author"
                                            width="11.2px"
                                            height="14px"
                                            background-color="#cfa04f;" />
                                    </div>
                                    <div className="descriptionForDoc">
                                        You can upload the JPEG or PNG format less than 2 Mb
                                    </div>
                                    {isErrorInPanVerification ? (
                                        <div className="alertForDoc">
                                            {panVerifyError}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>

                            <div className="instructionsToUpload">
                                <div className="samplePanSection">
                                    <div className="samplePanImage">
                                        <img src={'/assets/images/pan-card.jpeg'} alt={"sample pan"}
                                            height={120} width={220} />
                                    </div>
                                </div>
                                <div className="list">
                                    <ul>
                                        <li>You can upload the JPEG or PNG format</li>
                                        <li>Document size should be less than 2 Mb</li>
                                        <li>Image should be clearly visible</li>
                                        <li>Cropped or cut images will not be accepted</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}

                    {isPan && (
                        <div className="uploadPan">
                            <div className="panDetails">
                                <div className="documentUploadDone">
                                    <span className="updatePan">
                                        Update PAN
                                    </span>
                                    {/* {!panDetails && (<div className="panMessageBlock">
                                        <div className="panMessage">
                                            Pan details are mandatory for transactions above ₹1,000
                                        </div>
                                    </div>)} */}
                                    <div className="documentName">Document Uploaded</div>
                                    <div className="container changeUploadedDetails">
                                        <div>
                                            <div className="row documentFileName">
                                                {documentName?.name.slice(0, 15) + "..."}
                                            </div>
                                            <div className="row documentFileName">
                                                {validatePanDetails ? "*******" + validatePanDetails.doc_id.slice(7, 10) : ""}
                                            </div>
                                        </div>
                                        <div className={"changeButtonSection"}>
                                            <Button className="uploadDocuments" type="button" onClick={e => {
                                                setSubmitPanDetail(false);
                                                setIsUploadPan(true);
                                                setIsPan(false);
                                            }}>
                                                Change
                                            </Button>
                                        </div>
                                    </div>
                                    {/* <FormControlLabel 
                                        sx={{width:'fit-content'}} 
                                        control={
                                            <Checkbox 
                                                checked={panOperative}
                                                onChange={(_, checked) => setPanOperative(checked)}
                                            />
                                        } 
                                        label="PAN Operative"
                                     /> */}
                                </div>

                                <div className="instructionsToUpload">
                                    <div className="">
                                        <img src={document[0].uri} alt={"pan card image"} width={250}
                                            height={150} />
                                    </div>
                                </div>
                            </div>

                            <div className="mobilePanImg ">
                                <img src={document[0].uri} alt={"pan card image"} width={300} height={150} />
                            </div>                            

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button variant='contained' onClick={handleSubmit} >Submit</Button>
                            </div>
                        </div>
                    )}
                    {submitPanDetail && panDetails && (
                        <div className="profilePanStatus">

                            <div className="updatePanBar">

                                {/*<div className="changePan">*/}
                                {/*    <button className="uploadDocuments" type="button" onClick={e => {*/}
                                {/*        setDocument([{uri: ''}]);*/}
                                {/*        setIsUploadPan(true);*/}
                                {/*        setSubmitPanDetail(false);*/}
                                {/*    }}>*/}
                                {/*        CHANGE*/}
                                {/*    </button>*/}
                                {/*</div>*/}

                            </div>

                            <div className="profileShowPanDetails">
                                <div className="profileKycHeading">
                                    PAN details
                                </div>
                                <div className="kycPanNo">
                                    {maskedPanNumber}
                                </div>

                                {panDetails && (<div className="profilePanMessageBlock">
                                    <div className="profilePanMessage">
                                        Please reach out to customer care, in order to change the PAN Card
                                        details
                                    </div>
                                </div>)}
                            </div>
                        </div>
                    )}
                </>
            )
            }
            {submitPanDetail && !panDetails && !panStatus && (
                <div className="panStatus">

                    <div className="updatePanBar">

                        <div className="panUpdate">
                            <div>
                                <img src={'/assets/images/confirm.png'}
                                    className="confirmImg"
                                    alt="confirmSign"
                                />
                            </div>
                            <div>
                                <span className="imageDescription">
                                    Update Pan
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="showPanDetails">
                        <div className="panNo">
                            PAN Card Number
                        </div>
                        <div className="panNoDigit">
                            {maskedPanNumber}
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default CustomerPanUpload
